﻿import * as React from 'react';
import styles from './style.module.scss';

interface Props {
    [key: string]: any;
    className?: string;
    hideCloseButton?: boolean;
    title: string;
    children?: React.ReactNode;
}

export class ModalDialog extends React.Component<Props> {
    private dialog: React.RefObject<HTMLDialogElement> = React.createRef();

    public show = () => {
        this.dialog.current.show();
    }

    public showModal = () => {
        this.dialog.current.showModal();
    }

    public close = () => {
        this.dialog.current.close();
    }

    public render() {
        const { children, className, title, hideCloseButton, ...props } = this.props;

        return (
            <dialog ref={this.dialog} className={`${styles.dialog} ${className}`} {...props}>
                <header>
                    <div>{title}</div>
                    {!hideCloseButton && (
                        <button type="button" className={styles.closeButton} onClick={this.close}>X</button>
                    )}
                </header>
                <section className={styles.content}>
                    {children}
                </section>
            </dialog>
        );
    }
}

